export default __webpack_public_path__ + "static/media/git.6d27b5e0.svg";